import React from 'react';
import { AuthProvider } from "./AuthContext";
import {BrowserRouter, Routes, Route} from 'react-router-dom';

import Home from './Pages/Home';
import Contact from './Pages/Contact';
import DesiCowGhee from './Pages/DesiCowGhee';
import OurStory from './Pages/OurStory';
import TrackOrder from './Pages/TrackOrder';
import OrdersDetail from './Pages/OrdersDetail';
import Reviewus from './Pages/Reviewus';
import Login from './Pages/Login';
import Register from './Pages/Register';
import Cart from './Pages/Cart';
import ProductCarousel from './Pages/ProductCarousel';
import  Ourpolicies from './Pages/Ourpolicies';
import  Privacypolicies from './Pages/privacy-policy';
import Checkout from './Pages/Checkout';
import ScrollToTop from './Components/ScrollToTop';
import  Blog from './Pages/Blog';
import  ArticleCard from './Pages/ArticleCard';
import OurProducts from './Pages/OurProducts';
import CategoryProduct from './Pages/CategoryProduct';
import AllProducts from './Pages/AllProducts';
import Returnpolicies from './Pages/return-policy';
import Shippingpolicies from './Pages/shipping-policy';
import TermsConditions from './Pages/terms-conditions';
import { CartProvider } from "./CartContext";
import Orderpop from './Pages/Orderpop';
import ProfilePage  from './Pages/ProfilePage';
import MyOrders  from './Pages/MyOrders';
import Complaint  from './Pages/Complaint';
import NotFound from './Pages/NotFound';
 
function App() {
  const user = JSON.parse(localStorage.getItem("user"));
      return (
        <AuthProvider>
        <div className="App">
          <CartProvider>      
          <BrowserRouter>
          <ScrollToTop /> 
          <Routes>
                {/* pages */}
                <Route path='/' element={<Home />} />
                <Route path='/home' element={<Home />} />
                <Route path='/contact' element={<Contact />} />
                <Route path='/desi-cow-ghee' element={<DesiCowGhee />} />
                <Route path='/our-story' element={<OurStory />} />
                <Route path='/track-order' element={<TrackOrder />} />
                <Route path='/orders/:id' element={<OrdersDetail />} />
                <Route path='/reviewus' element={<Reviewus />} />
                <Route path='/login' element={<Login />} />
                <Route path='/register' element={<Register/>} />
                <Route path='/cart' element={<Cart/>} />
                <Route path='/product/:slug' element={<ProductCarousel/>} />
                <Route path='/our-policies' element={<Ourpolicies/>} />
                <Route path='/privacy-policy' element={<Privacypolicies/>} />
                <Route path='/checkout' element={<Checkout/>} />
                <Route path='/blog' element={<Blog/>} />
                <Route path='/blogs/:slug' element={<ArticleCard/>} />
                <Route path='/our-products' element={<OurProducts/>} />
                <Route path="/category/:slug" element={<CategoryProduct />} />
                <Route path="/all-products" element={<AllProducts />} />
                <Route path="/return-policy" element={<Returnpolicies />} />
                <Route path="/shipping-policy" element={<Shippingpolicies />} />
                <Route path="/terms-conditions" element={<TermsConditions />} />
                <Route path="/orderpop" element={<Orderpop />} />
                <Route path="/my-profile" element={<ProfilePage user={user} />} />
                <Route path="/my-orders" element={<MyOrders user={user} />} />
                <Route path="/complaint" element={<Complaint user={user} />} />
               <Route path="*" element={<NotFound />} />
              </Routes>
          </BrowserRouter>
          </CartProvider>
        </div>
        </AuthProvider>
      );
}

export default App;





